import { inject, Injectable } from '@angular/core';
import { IrisService } from '@shared/services/iris.service';
import { map, Observable } from 'rxjs';
import { format, isWithinInterval, parseISO, startOfDay } from 'date-fns';
import { HolidayItem } from '@setup/workspace/data-access/type/holiday.type';

@Injectable({
  providedIn: 'root',
})
export class HolidayClosureService {
  private readonly _irisService = inject(IrisService);

  /**
   * Get the upcoming holiday within next 7 days
   */

  getUpcomingHoliday(): Observable<HolidayItem | null> {
    return this._irisService.getHolidays().pipe(
      map((holidays) => {
        if (!holidays?.data?.length) return null;

        const today = startOfDay(new Date());

        const sortedHolidays = holidays.data.sort((a: any, b: any) => {
          const dateA = startOfDay(parseISO(a.start_date));
          const dateB = startOfDay(parseISO(b.start_date));
          return dateA.getTime() - dateB.getTime();
        });

        const next = sortedHolidays.find((h: any) => {
          const start = startOfDay(parseISO(h.start_date));
          const end = startOfDay(parseISO(h.end_date));
          const sevenDaysBefore = new Date(start);
          sevenDaysBefore.setDate(sevenDaysBefore.getDate() - 7);

          return isWithinInterval(today, { start: sevenDaysBefore, end });
        });

        if (!next) return null;

        const start_date = format(parseISO(next.start_date), 'EEEE, MMMM d');
        const end_date = format(parseISO(next.end_date), 'EEEE, MMMM d');

        return {
          id: next.id,
          name: next.name,
          single: start_date === end_date,
          start_date,
          end_date,
          created_dt: next.created_dt,
          updated_dt: next.updated_dt,
        };
      }),
    );
  }
}
